<template>
  <div class="wiki-detail-comment" :style="{ height: isPage ? 'auto' : '70vh' }">
    <div v-if="needLogin && isCommentTop" ref="sendComment" class="detail-comment">
      <detail-comment-send
        ref="sendBox"
        :on-ok="onComment"
        placeholder="写下友好的评论，有助于彼此更好地交流"
        :send-btn-text="$t('comment')"
        :show-video="false"
        :show-cancel="true"
        :showToolBar="showToolBar"
        @paste="handlePaste"
        @focus="onInputFocus"
        @cancel="onInputCancel"
      >
      </detail-comment-send>
    </div>
    <!-- <DetailEasyTool v-if="!isCommentTop" :detail="detail" @heightChange="onHeightChange" @comment="onComment" /> -->
    <div v-if="needLogin && showCommentList" class="wiki-comment-list" :style="{ height: isPage ? 'auto' : 0 }">
      <template v-if="!isPage">
        <el-scrollbar ref="scrollbar" style="flex-grow: 1; height: 0; overflow: hidden;">
          <div
            ref="commentList"
            class="list"
            v-infinite-scroll="getCommentList"
            :infinite-scroll-delay="350"
            :infinite-scroll-distance="60"
          >
            <template v-if="list.length">
              <div v-for="(item, index) in list" :key="item.id">
                <comment-list-item
                  :type="type"
                  :floor="'#' + (pagination.total - index)"
                  :is-lz="item.user.uid == user.uid"
                  :item="item"
                  :pid="item.id"
                  @onDel="onDelComment"
                  @onTop="onTopComment"
                />
                <detail-ad v-if="index == 4" :detail="detail" />
              </div>
              <div class="no-more" v-if="list.length == pagination.total">
                没有更多数据了
              </div>
            </template>
            <template v-else>
              <div class="empty-box">
                <img class="empty-icon" src="@/assets/images/comment-empty-icon.png" alt="" />
                <div class="empty-txt">观看就是喜欢，快来评论一下吧！</div>
                <!-- <div class="btn-box">
                <el-button class="button" type="text">点击评论</el-button>
              </div> -->
              </div>
            </template>
          </div>
        </el-scrollbar>
      </template>
      <template v-if="isPage">
        <div class="list">
          <template v-if="list.length">
            <div v-for="(item, index) in list" :key="item.id">
              <comment-list-item
                :type="type"
                :floor="'#' + (pagination.total - index)"
                :is-lz="item.user.uid == user.uid"
                :item="item"
                :pid="item.id"
                @onDel="onDelComment"
                @onTop="onTopComment"
              />
              <detail-ad v-if="index == 4" :detail="detail" />
            </div>
            <div class="no-more" v-if="list.length == pagination.total">
              没有更多数据了
            </div>
          </template>
          <template v-else>
            <div class="empty-box">
              <img class="empty-icon" src="@/assets/images/comment-empty-icon.png" alt="" />
              <div class="empty-txt">观看就是喜欢，快来评论一下吧！</div>
              <!-- <div class="btn-box">
                <el-button class="button" type="text">点击评论</el-button>
              </div> -->
            </div>
          </template>
        </div>
      </template>
    </div>
    <!-- 查看评论 -->
    <comment-dialog :type="type" />

    <!-- 游客评论弹窗 -->
    <SightseerCommentTips ref="sightseerCommentTips"></SightseerCommentTips>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Message } from "element-ui";
// components
import DetailCommentSend from "./detailCommentSend";
// import DetailEasyTool from "./detailEasyTool";
import CommentListItem from "../../components/commentListItem";

import CommentDialog from "../../components/commentDialog";
import SightseerCommentTips from "../../components/sightseerCommentTips";
import DetailAd from "./detailAd.vue";
// api
import { apiCommentAdd, apiSightseerCommentAdd } from "@/api/commentApi";
// plguins
import eventBus from "@/plugins/eventBus";
import { newDebounce, debounce, toast } from "@/plugins/util";
import { uploadFile } from "@/plugins/uploadFile";

export default {
  name: "DetailComment",
  inject: ["getWxaQrcode", "getServiceQrcodeSrc"],
  components: {
    DetailCommentSend,
    CommentListItem,
    CommentDialog,
    SightseerCommentTips,
    DetailAd
    // DetailEasyTool
  },
  props: {
    detail: {
      type: Object,
      default: () => ({})
    },
    user: {
      type: Object,
      default: () => ({})
    },
    list: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object,
      default: () => ({})
    },
    loadCommentStatus: {
      type: String,
      default: ""
    },
    type: {
      type: Number,
      default: 0
    },
    /** 是页面中的评论还是弹窗中的评论 */
    isPage: { type: Boolean, default: false },
    /** 是否显示评论列表 */
    showCommentList: { type: Boolean, default: true }
  },
  data() {
    return {
      loading: false,
      isCommentTop: true,
      /** DetailEasyTool组件在输入框未聚焦时的初始高度为61，在聚焦后会监听其高度变化然后上报并计算得出该值（methods.onHeightChange） */
      commentBoxHeight: 61,
      showToolBar: false
    };
  },
  computed: {
    ...mapGetters(["loginUid", "loginUser"])
  },
  watch: {
    loadCommentStatus(val, oVal) {
      this.$refs.scrollComp.loadStatus = val;
    }
  },
  mounted() {
    // 锚点定位
    setTimeout(() => {
      const ancher_id = sessionStorage.getItem("jumpDetailAnchorId");
      if (ancher_id) {
        window.scrollTo({
          top: document.getElementById(ancher_id).offsetTop,
          behavior: "smooth"
        });
        sessionStorage.removeItem("jumpDetailAnchorId");
      }
    }, 1000);
    // 查询未发出的评论
    const storeComment = localStorage.getItem("__comment_store__");

    if (storeComment && this.isLogin()) {
      if (!this.isAuthRealName("实名认证后才能评论")) {
        return false;
      }
      const commentParams = JSON.parse(storeComment);
      this._comment(commentParams);
    }

    // this.listenCommentScroll();
  },
  beforeDestroy() {
    eventBus.$off("onCommentLoginClose", this.sightseerComment);
    this.listenCommentScrollRemove();
  },
  methods: {
    // 游客评论
    sightseerComment: newDebounce(function(showTips = true) {
      // 查询未发出的评论
      const storeComment = localStorage.getItem("__comment_store__") || "";
      const params = JSON.parse(storeComment);
      apiSightseerCommentAdd(params)
        .then(res => {
          if (res && res.code === 0) {
            if (showTips) {
              this.$refs.sightseerCommentTips.open();
              // 10s后自动关闭
              setTimeout(() => {
                this.$refs.sightseerCommentTips.close();
              }, 10000);
            }
          }
        })
        .finally(() => {
          // 删除缓存
          localStorage.removeItem("__comment_store__");
          eventBus.$off("onCommentLoginClose", this.sightseerComment);
        });
    }, 1000),
    // 添加评论
    onComment(data) {
      const { text, resources } = data;
      let content = text;
      if (resources.length) {
        let imgs = '<div class="comment-img-wrapper">';
        resources.forEach(item => {
          imgs += `<div class="img-item"><img src="${item.url}" alt=""></div>`;
        });
        imgs += "</div>";
        content += imgs;
      }
      let params = {
        content: content,
        content_id: this.detail.id,
        pid: 0,
        type: Number(this.type) // 评论类型，默认为0
      };

      // 校验
      if (!data.text && resources.length === 0) {
        this.$message({
          type: "info",
          message: "内容为空，请输入！"
        });
        return;
      }
      if (!this.isLoginShow("", "commentLogin")) {
        eventBus.$once("onCommentLoginClose", () => {
          const timeoutTimer = setTimeout(() => {
            this.$refs.sightseerCommentTips.close();
          }, 10000);
          this.$refs.sightseerCommentTips.open();
          this.$refs.sightseerCommentTips.$once("closed", value => {
            clearTimeout(timeoutTimer);
            if (value === "login") {
              eventBus.$once("onCommentLoginClose", () => {
                this.sightseerComment(false);
              });
            } else {
              this.sightseerComment(false);
            }
          });
        });
        localStorage.setItem("__comment_store__", JSON.stringify(params));
        return false;
      }
      if (!this.isAuthRealName("实名认证后才能评论")) return false;
      console.log(params);
      this._comment(params);
    },
    _comment(params) {
      apiCommentAdd(params)
        .then(({ code, data }) => {
          if (code === 0) {
            if (this.loginUid && this.loginUser.is_bind_min_app) {
              toast("评论成功");
            } else {
              // 提示可前往小程序
              this.$message({
                title: "",
                customClass: "publish-miniapp-tips",
                duration: 0,
                showClose: true,
                message: (
                  <div class="miniapp-tips-content">
                    <div class="title">
                      <img src={require("@/assets/images/ok-icon.png")} />
                      恭喜您 评论成功
                    </div>
                    <div class="content">
                      <div class="qrcode">
                        <img src={this.getServiceQrcodeSrc()} alt="服务号二维码" />
                      </div>
                      <div class="tips">
                        <div class="title">扫码关注GameKee服务号</div>
                        <div class="desc">随时接收最新消息</div>
                        <div class="tags">
                          <span>评论回复</span>
                          <span>点赞收藏</span>
                          <span>攻略讨论</span>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              });
              // xxs后关闭
              const duration = this.loginUid && this.loginUser.is_bind_min_app ? 3 * 1000 : 10 * 1000;
              setTimeout(() => {
                Message.closeAll();
              }, duration);
            }

            this.detail.comment_count++;
            this.$emit("refresh", this.detail);
            this.getCommentList("refresh");
            this.$refs.sendBox.onClear();
          }
        })
        .finally(_ => {
          this.$emit("setLoading", false);
          // 删除缓存
          localStorage.removeItem("__comment_store__");
          eventBus.$off("onCommentLoginClose", this.sightseerComment);
        });
    },
    // 获取评论列表
    getCommentList(type) {
      this.$emit("getCommentList", type);
    },
    // 删除评论
    onDelComment(item) {
      let index = this.list.indexOf(item);
      this.list.splice(index, 1);
      this.detail.comment_count--;
      this.$emit("refresh", this.detail);
    },
    // 置顶评论
    onTopComment(item) {
      this.$emit("getCommentList", "refresh");
    },
    // 滚动到评论处
    async onScrollToCommentBox() {
      if (!this.isLoginShow()) return false;

      let $ele = this.$refs.sendComment;
      $ele.querySelector(".article-edit-box").focus();
      await this.$nextTick();
      window.scrollTo({
        top: $ele.offsetTop,
        behavior: "smooth"
      });
    },
    handleClickEdit() {
      if (!this.isLoginShow("")) return false;
      if (!this.isAuthRealName("")) return false;
      this.$router.push(`/${this.gameInfo.alias}/editor`);
    },
    listenCommentScroll() {
      /** @type {HTMLDivElement} */
      if (this.$refs.commentList) {
        const scrollWrap = this.$refs.commentList.closest("div.el-scrollbar__wrap");
        scrollWrap.addEventListener("scroll", this.onCommentScroll);
      }
    },
    listenCommentScrollRemove() {
      /** @type {HTMLDivElement} */
      if (this.$refs.commentList) {
        const scrollWrap = this.$refs.commentList.closest("div.el-scrollbar__wrap");
        scrollWrap.removeEventListener("scroll", this.onCommentScroll);
      }
    },
    onCommentScroll(event) {
      if (this.list.length <= 6) return;
      /** @type {HTMLDivElement} */
      const scrollWrap = event.target;
      const lastScrollTop = this.lastScrollTop || 0;
      this.lastScrollTop = scrollWrap.scrollTop;
      if (scrollWrap.scrollTop > lastScrollTop && scrollWrap.scrollTop > 0) {
        this.isCommentTop = false;
        this.updateScrollbar();
        this.$emit("scrollArrowBottom");
      }
      if (scrollWrap.scrollTop === 0) {
        this.isCommentTop = true;
        this.updateScrollbar();
        this.$emit("scrollToTop");
      }
    },
    onHeightChange(height) {
      // 14为内边距13px加上边框1px
      this.commentBoxHeight = height + 14;
      this.updateScrollbar();
    },
    onInputFocus() {
      this.showToolBar = true;
    },
    // 在光标位置插入文本
    insertTextAtCursor(text) {
      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        range.deleteContents();
        const textNode = document.createTextNode(text);
        range.insertNode(textNode);

        // 移动光标到插入文本之后
        range.setStartAfter(textNode);
        range.collapse(true);
        selection.removeAllRanges();
        selection.addRange(range);
      } else {
        // 如果没有选中区域，直接追加到内容末尾
        this.$refs.textBox.innerHTML += text;
      }
    },
    handlePaste(e) {
      e.preventDefault();
      const clipboardData = e.clipboardData || window.clipboardData;

      // 处理文本
      const pastedText = clipboardData.getData("text/plain");
      if (pastedText) {
        this.insertTextAtCursor(pastedText);
      }

      // 处理图片
      const items = clipboardData.items;
      for (let i = 0; i < items.length; i++) {
        console.log(items[i]);
        if (items[i].type.indexOf("image") !== -1) {
          const blob = items[i].getAsFile();
          console.log("上传信息", blob);

          const url = URL.createObjectURL(blob);
          const item = {
            file: blob,
            percent: 0,
            type: "img",
            url,
            key: parseInt(Math.random() * 1000000)
          };
          this.resources.push(item);
          // 上传图片（如果有上传逻辑）
          uploadFile({
            file: blob,
            percent: 0,
            progressCb: percent => {
              item.percent = percent;
            }
          }).then(res => {
            item.percent = 100;
            item.url = res.url; // 替换为服务器返回的URL
          });

          break;
        }
      }
    },
    onInputCancel() {
      this.showToolBar = false;
      this.$refs.sendBox.onClear();
    },
    /** 评论区域高度变化时，重新计算滚动条位置 */
    updateScrollbar: debounce(function() {
      const scrollbar = this.$refs.scrollbar;
      scrollbar && scrollbar.update();
    }, 100)
  }
};
</script>

<style lang="less" scoped>
.wiki-detail-comment {
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 28px;
}
.detail-comment {
  background-color: #fff;
  border-radius: 4px;
}

.wiki-comment-list {
  background: #fff;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  height: 0;
  flex-grow: 1;
  /deep/ .el-scrollbar__wrap {
    overflow-x: hidden;
    padding-right: 14px;
  }

  .no-more {
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 17px;
    text-align: center;
  }

  .empty-box {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 90px;
    .empty-icon {
      width: 107px;
      height: 80px;
      margin-bottom: 29px;
    }

    .empty-txt {
      font-weight: 400;
      font-size: 12px;
      color: #333333;
      line-height: 17px;
      margin-bottom: 10px;
    }

    .btn-box {
      text-align: center;
      .button {
        font-weight: 400;
        font-size: 12px;
        color: #00afe8;
        line-height: 17px;
      }
    }
  }
}
/deep/ .comment-img-wrapper {
  display: flex;
  margin-bottom: 20px;

  .img-item {
    width: 110px;
    height: 100px;
    cursor: pointer;
    position: relative;
    border-radius: 6px;
    overflow: hidden;

    & + .img-item {
      margin-left: 12px;
    }

    .mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: fade(#000, 70%);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 16px;
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
